export const MAX_EXPLORES_SELECTION_SIZE = 250;

/** Max rows per page for explore row-level ad-hoc queries (matches display table UI/repo cap). */
export const MAX_EXPLORE_ROW_LEVEL_PAGE_SIZE = 250;

export const COUNT_STAR_ARG = "_HEX_COUNT_STAR_ARG_";
export const COUNT_STAR_LABEL = "Count of Records";
export const COUNT_STAR_CALC = "COUNT()";

export const CHART_FOLD_KEYS = "CHART_FOLD_KEYS";
export const CHART_FOLD_VALUES = "CHART_FOLD_VALUES";
export const VALUES_AS_ROWS_COLUMN_NAME = `_HEX_PIVOT_VALUE_COLUMN_`;
